import { AlertSeverity } from '@mulesoft/monitoring-center-components/lib/components/Selector/SeveritySelector/model'

export const alertStateFilterOptions = [
  {key: 'ALL',  label: 'All states'},
  {key: 'no_data',  label: 'No data'},
  {key: 'paused',  label: 'Paused'},
  {key: 'alerting',  label: 'Alerting'},
  {key: 'ok',  label: 'Ok'},
  {key: 'pending',  label: 'Pending'},
]

export const alertSeverityFilterOptions = [
  {key: 'ALL', label: 'All severities'},
  {key: AlertSeverity.CRITICAL, label: 'Critical'},
  {key: AlertSeverity.WARNING, label: 'Warning'},
  {key: AlertSeverity.INFO, label: 'Info'},
  {key: 'undefined', label: 'Not defined'},
]

export const alertResourceFilterOptions = [
  {key: 'ALL', label: 'All resource types'},
  {key: 'application', label: 'Applications'},
  {key: 'target', label: 'Targets'},
  {key: 'api', label: 'APIs'},
  {key: 'panel', label: 'Custom dashboard panels'},
]

export const alertTypeFilterOptions = [
  {key: 'basic', label: 'Basic Alerts'},
  {key: 'advanced', label: 'Advanced Alerts'},
]

export const isAllFilter = (key: string) => key === 'ALL'
